export var BackgroundTaskType;
(function (BackgroundTaskType) {
    // The old system "actions", dont change names to make any migration easier
    BackgroundTaskType["ORGANISATION_DISCONNECT"] = "organisation_disconnect";
    BackgroundTaskType["SCHEDULED_MOPUP"] = "scheduled_mopup";
    BackgroundTaskType["BULK_DOWNLOAD_INVOICES_SUB_TASK"] = "bulk_download_invoices_sub_task";
    BackgroundTaskType["SEND_SMS_LIMIT_REACHED_EMAIL"] = "send_sms_limit_reached_email";
    BackgroundTaskType["EXPORT_CONTACTS"] = "export_contacts";
    BackgroundTaskType["EXPORT_INVOICES"] = "export_invoices";
    BackgroundTaskType["EXPORT_ACTIONS"] = "export_actions";
    BackgroundTaskType["EXPORT_ESCALATIONS"] = "export_escalations";
})(BackgroundTaskType || (BackgroundTaskType = {}));
// Also same as actions, for easier migration
export var BackgroundTaskStatus;
(function (BackgroundTaskStatus) {
    BackgroundTaskStatus["PENDING"] = "pending";
    /** Processed */
    BackgroundTaskStatus["COMPLETE"] = "complete";
    /** Failed */
    BackgroundTaskStatus["FAILED"] = "failed";
})(BackgroundTaskStatus || (BackgroundTaskStatus = {}));
//# sourceMappingURL=backgroundTask.js.map